import { Icon } from '@/components/generic';
import { useTranslation } from 'react-i18next';

const SelfCustodyDisclaimer = () => {
  const { t } = useTranslation();

  return (
    <div className='p-4 mb-3 bg-primary-03/10 border border-primary-03/20 rounded-2xl w-full'>
      <div className='flex items-start gap-3 justify-start'>
        <div className='flex-shrink-0  '>
          <div className='flex items-center justify-center w-6 h-6 bg-primary-03/15 rounded-full'>
            <Icon name='info' className='w-4 h-4 fill-primary-03' />
          </div>
        </div>
        <div className='flex-1 '>
          <p className='text-body-2 text-t-primary leading-relaxed'>
            {t('wallet.disclaimer')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SelfCustodyDisclaimer;
